import $ from "jquery";

export const UserQuestion = function () {
	if (!($(".user-question-page").length > 0)) return false;

	const $elms = {
		page: $(".user-question"),
		sliderInput: $(".js-slider-input"),
		submitAnswers: $(".js-submit-answers"),
		answerProgressBar: $(".js-answer-progress-bar"),
		userQuestionAction: $(".js-user-question-action"),
		toggleOptionalQuestions: $(".js-toggle-optional-questions"),
		optionalQuestionsContent: $(".js-optional-questions-content"),
		tempSavebtn: $(".js-temp-save-progress"),
		toggleQuestionGroupBtn: $('.js-expand-question'),
		optionalQuestions: $('.js-optional-question'),
		optionalQuestionfilter: $('.js-filter-optional-question'),
		optionalQuestionPlaceholder: $('.js-filter-placeholder'),
		optionalQuestionWrap: $(".js-filter-optional-question-wrap"),
	};

	$elms.sliderInput.on("input", function () {
		const $this = $(this);
		const questionId = $this.data("question-id");
		const value = $this.val();
		const feedbacks = window.CFG.data.question_feedback?.find(
			(item) => item.ID === questionId,
		);

		// Check mandatory questions after each input change
		checkMandatoryQuestions();

		if (!feedbacks || !feedbacks.feedback) return;

		const feedback = feedbacks.feedback?.find(
			(f) =>
				parseInt(value) >= parseInt(f.range_min) &&
				parseInt(value) <= parseInt(f.range_max),
		);

		const $sliderFeedback = $this
			.closest(".slider")
			.siblings(".slider__feedback");

		if (feedback) {
			$sliderFeedback.text(feedback.feedback);
			$sliderFeedback.show();
		} else {
			$sliderFeedback.hide();
		}
	});

	$elms.toggleQuestionGroupBtn.on("click", function() {		   	
        const $this = $(this);
        const hasOpened = $this.hasClass("is-active");
        const isOpen = !hasOpened;

        $this.stop().toggleClass("is-active", isOpen);
	})

	$elms.tempSavebtn.on("click", function() {		
        const $tempPopup = $(".js-temp-save-popup");
        const hasOpened = $tempPopup.hasClass("is-shown");
        const isOpen = !hasOpened;

        $tempPopup.toggleClass("is-shown", isOpen);
		$elms.tempSavebtn.toggleClass("is-disabled", isOpen);

		const answers = [];
		$elms.sliderInput.each(function () {
			const $this = $(this);
			const questionId = $this.attr("data-question-id");
			const value = $this.val();
			const isMandatory = $this.attr("is-mandatory") === "1";

			// Always include mandatory questions
			if (isMandatory) {
				answers.push({ questionId, value: parseInt(value) });
			} else {
				// Only include optional questions if the content is visible
				if ($elms.optionalQuestionsContent.is(":visible")) {
					answers.push({ questionId, value: parseInt(value) });
				}
			}
		});

	const phase = $elms.page.attr("data-phase");
	const data = {
		phase: parseInt(phase),
		answers,
		nonce: window.CFG.nonce,
		action: "user-temporary-answer",
	};

	const startTime = Date.now();
	const minDisplayTime = 2000;

	$.ajax({
		url: window.CFG.ajaxUrl,
		type: "POST",
		data: data,
		success: function (response) {
			if (!response.success) {
				console.error(response.data.message || "Something went wrong");
			}
		},
		error: function (error) {
			console.error(error);
		},
		complete: function () {
			// show success message atleast for 2 seconds
			const elapsedTime = Date.now() - startTime;
			const remainingTime = Math.max(0, minDisplayTime - elapsedTime);

			setTimeout(function () {
				$tempPopup.removeClass("is-shown");
				$elms.tempSavebtn.removeClass("is-disabled");
			}, remainingTime);
		},
	});
	});

	$elms.optionalQuestionfilter.on("click", function() {
		$elms.optionalQuestionfilter.removeClass("is-active");
		$(this).addClass("is-active");
		filterOptionalQuestion();
		toggleFilterWrap();
	});
	
	
	$elms.optionalQuestionPlaceholder.on("click", function() {
		toggleFilterWrap();
	})

	function checkMandatoryQuestions() {
		const $unansweredMandatoryQuestions = $elms.sliderInput.filter(function () {
			const $slider = $(this);
			return (
				$slider.attr("is-mandatory") === "1" &&
				$slider.attr("is-activated") === "0"
			);
		});

		$elms.submitAnswers.toggleClass(
			"is-disabled",
			$unansweredMandatoryQuestions.length > 0,
		);

		// Update progress bar after checking mandatory questions
		updateProgressBar();
	}

	function updateProgressBar() {
		// Get mandatory questions
		const $mandatoryQuestions = $elms.sliderInput.filter(function () {
			const $slider = $(this);
			return $slider.attr("is-mandatory") === "1";
		});

		// Get optional questions (only if content is visible)
		// Currently disabled since optional questions not mandatory even if the content is visible
		const $optionalQuestions = $();
		// const $optionalQuestions = $elms.optionalQuestionsContent.is(":visible")
		// 	? $elms.sliderInput.filter(function () {
		// 			const $slider = $(this);
		// 			return $slider.attr("is-mandatory") === "0";
		// 		})
		// 	: $();

		// Combine questions based on visibility
		const $totalQuestions = $mandatoryQuestions.add($optionalQuestions);
		const totalQuestions = $totalQuestions.length;

		const answeredQuestions = $totalQuestions.filter(function () {
			const $slider = $(this);
			return $slider.attr("is-activated") === "1";
		}).length;

		const progressPercentage =
			totalQuestions > 0 ? (answeredQuestions / totalQuestions) * 100 : 0;
		$elms.answerProgressBar.css("width", `${progressPercentage}%`);

		$(".js-answer-progress-number").text(answeredQuestions);
		$(".js-answer-progress-total").text(totalQuestions);

		if (answeredQuestions === totalQuestions) {
			$elms.userQuestionAction.addClass("is-ready");
		} else {
			$elms.userQuestionAction.removeClass("is-ready");
		}
	}

	function filterOptionalQuestion() {
		$('.js-filter-optional-question.is-active').each(function() {
			const label = $(this).find("span").text();
			const dataLearning = $(this).data("learning");

			$elms.optionalQuestionPlaceholder.text(label);
			toggleOptionalQuestion(dataLearning)
		})
	}

	function toggleFilterWrap() {
		const $wrap = $elms.optionalQuestionWrap;
		const space = $wrap.outerHeight();
		const winScroll = $(window).scrollTop();
        const hasOpened = $wrap.hasClass("is-active");
        const isOpen = !hasOpened;

        $wrap.stop().toggleClass("is-active", isOpen);
		$('.js-optional-questions-content').css('margin-bottom', space+'px');
		$(window).scrollTop(winScroll+space);
	}

	function toggleOptionalQuestion(dataLearning) {
		// Hide all optional questions first
		$('.optionalQuestions__items .user-question__item').hide();

		// Show questions that contain the selected learning goal ID
		$('.optionalQuestions__items .user-question__item').each(function() {
			const $item = $(this);
			const learningGoals = $item.data('learning');
			
			if (!learningGoals) return;
			
			// Convert to string and split by comma if multiple IDs
			const learningGoalIds = learningGoals.toString().split(',').map(id => id.trim());
			
			// Check if the selected learning goal ID is in the list
			if (learningGoalIds.includes(dataLearning.toString())) {
				$item.show();
			}
		});
	}

	// Initial check when page loads
	checkMandatoryQuestions();
	// Initial progress bar update
	updateProgressBar();

	$elms.submitAnswers.on("click", function () {
		const $this = $(this);
		const isSubmitted = $this.attr("data-is-submitted");

		if ($this.hasClass('is-disabled')) {
			$('.js-answer-all-questions-popup').addClass("is-shown");

			setTimeout(function() {
				$('.js-answer-all-questions-popup').removeClass("is-shown");
			}, 2000);
		} else {				
			if (isSubmitted === "1") {
				window.location.href = $this.attr("data-next-url");
				return;
			}
		}

		if ($this.hasClass("is-loading")) return;

		$this.addClass("disabled");
		$this.addClass("is-loading");

		const phase = $elms.page.attr("data-phase");

		const $unansweredMandatoryQuestions = $elms.sliderInput.filter(function () {
			const $slider = $(this);
			return (
				$slider.attr("is-mandatory") === "1" &&
				$slider.attr("is-activated") === "0"
			);
		});

		if ($unansweredMandatoryQuestions.length > 0) {
			$this.removeClass("is-loading");
			
			$('.js-answer-all-questions-popup').addClass("is-shown");

			setTimeout(function() {
				$('.js-answer-all-questions-popup').removeClass("is-shown");
			}, 2000);

			return;
		}

		const answers = [];
		$elms.sliderInput.each(function () {
			const $this = $(this);
			const questionId = $this.attr("data-question-id");
			const value = $this.val();
			const isMandatory = $this.attr("is-mandatory") === "1";

			// Always include mandatory questions
			if (isMandatory) {
				answers.push({ questionId, value: parseInt(value) });
			} else {
				// Only include optional questions if the content is visible
				if ($elms.optionalQuestionsContent.is(":visible")) {
					answers.push({ questionId, value: parseInt(value) });
				}
			}
		});

		const data = {
			phase: parseInt(phase),
			answers,
			nonce: window.CFG.nonce,
			action: "user-answer",
		};

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: data,
			success: function (response) {
				if (!response.success) {
					console.error(response.data.message || "Something went wrong");
					if (response.data.redirect) {
						window.location.href = response.data.redirect;
					}
				} else {
					window.location.href = response.data.redirect;
				}
			},
			error: function (error) {
				console.error(error);
			},
			complete: function () {
				$this.prop("disabled", false);
				$this.removeClass("is-loading");
			},
		});
	});

	function initializeSliders() {
		const sliders = document.querySelectorAll(".slider");

		// Function to convert hex or rgb string to RGB array
		function colorToRGB(color) {
			// Create a temporary div to use the browser's color parsing
			const temp = document.createElement("div");
			temp.style.color = color;
			document.body.appendChild(temp);
			const computedColor = window.getComputedStyle(temp).color;
			document.body.removeChild(temp);

			// Extract RGB values using regex
			const rgb = computedColor.match(/\d+/g).map(Number);
			return rgb;
		}

		sliders.forEach((sliderContainer) => {
			const sliderInput = sliderContainer.querySelector(".slider__input");
			const valueDisplay = sliderContainer.querySelector(
				".slider__value-display",
			);
			const customThumb = sliderContainer.querySelector(".slider__thumb");
			const thumbIcon = sliderContainer.querySelector(".slider__thumb svg");

			// Track if slider has ever been moved from 0
			let hasBeenActivated = false;

			function updateSlider(value) {
				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);

				valueDisplay.textContent = value;

				const percent = ((value - min) / (max - min)) * 100;

				const minThumbSize = 2; // 20px converted to em (20/16)
				const maxThumbSize = 3.125; // 50px converted to em (50/16)
				const thumbSize =
					minThumbSize + (percent / 100) * (maxThumbSize - minThumbSize);
				customThumb.style.width = `${thumbSize}em`;
				customThumb.style.height = `${thumbSize}em`;

				customThumb.style.left = `calc(${percent}% - ${thumbSize * (percent / 100 - 0.5)}em)`;

				// Mark as activated if value > 0
				if (value > 0) {
					hasBeenActivated = true;
					sliderInput.setAttribute("is-activated", "1");
				}

				// Apply colors if slider has been activated OR is currently > 0
				if (hasBeenActivated || value > 0) {
					// Activate colored track
					const track = sliderContainer.querySelector(".slider__track");
					const gradientLeft = track.getAttribute("data-gradient-left");
					const gradientRight = track.getAttribute("data-gradient-right");
					// track.style.background = `linear-gradient(to right, ${gradientLeft}, ${gradientRight})`;

					const startColor = colorToRGB(gradientLeft);
					const endColor = colorToRGB(gradientRight);
					const color = startColor.map((start, i) => {
						const end = endColor[i];
						return Math.round(start + (end - start) * (percent / 100));
					});

					// Show/hide icon based on value
					thumbIcon.style.opacity = value <= 3 ? "0" : "1";

					valueDisplay.style.color = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
					customThumb.style.backgroundColor = 'rgb(144, 224, 144)'//`rgb(${color[0]}, ${color[1]}, ${color[2]})`;
					track.style.background = `#f17f3c`;
				} else {
					// Keep grey state when slider has never been activated
					const track = sliderContainer.querySelector(".slider__track");
					track.style.background = "#cccccc";
					thumbIcon.style.opacity = "0";
					valueDisplay.style.color = "#999999";
					customThumb.style.backgroundColor = "#999999";
				}
			}

			// Add event listener for this specific slider
			sliderInput.addEventListener("input", (event) => {
				updateSlider(event.target.value);
				checkMandatoryQuestions();
			});

			// Add drag functionality to custom thumb
			let isDragging = false;

			function handleThumbDrag(event) {
				if (!isDragging) return;

				event.preventDefault();

				const sliderRect = sliderContainer
					.querySelector(".slider__wrapper")
					.getBoundingClientRect();
				const clientX = event.type.includes("touch")
					? event.touches[0].clientX
					: event.clientX;
				const percent = Math.max(
					0,
					Math.min(100, ((clientX - sliderRect.left) / sliderRect.width) * 100),
				);

				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);
				const value = Math.round(min + (percent / 100) * (max - min));

				sliderInput.value = value;
				updateSlider(value);

				// Trigger input event to call checkMandatoryQuestions()
				const inputEvent = new Event("input", { bubbles: true });
				sliderInput.dispatchEvent(inputEvent);
			}

			// Mouse events for custom thumb
			customThumb.addEventListener("mousedown", (event) => {
				if (sliderInput.disabled) return;

				isDragging = true;
				event.preventDefault();
				document.addEventListener("mousemove", handleThumbDrag);
				document.addEventListener("mouseup", () => {
					isDragging = false;
					document.removeEventListener("mousemove", handleThumbDrag);
				});
			});

			// Touch events for mobile
			customThumb.addEventListener("touchstart", (event) => {
				if (sliderInput.disabled) return;

				isDragging = true;
				event.preventDefault();
				document.addEventListener("touchmove", handleThumbDrag, {
					passive: false,
				});
				document.addEventListener("touchend", () => {
					isDragging = false;
					document.removeEventListener("touchmove", handleThumbDrag);
				});
			});

			// Add click functionality to slider track
			const sliderWrapper = sliderContainer.querySelector(".slider__wrapper");
			sliderWrapper.addEventListener("click", (event) => {
				if (sliderInput.disabled) return;

				// Don't trigger if clicking on the thumb itself
				if (event.target === customThumb || customThumb.contains(event.target))
					return;

				const sliderRect = sliderWrapper.getBoundingClientRect();
				const percent = Math.max(
					0,
					Math.min(
						100,
						((event.clientX - sliderRect.left) / sliderRect.width) * 100,
					),
				);

				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);
				const value = Math.round(min + (percent / 100) * (max - min));

				sliderInput.value = value;
				updateSlider(value);

				// Trigger input event to call checkMandatoryQuestions()
				const inputEvent = new Event("input", { bubbles: true });
				sliderInput.dispatchEvent(inputEvent);
			});

			// Initialize with current value
			updateSlider(sliderInput.value);
		});
	}

	filterOptionalQuestion();
	initializeSliders();
	checkMandatoryQuestions();

	$elms.toggleOptionalQuestions.on("click", function () {
		$elms.optionalQuestionsContent.toggle();
		// Update progress bar after toggling optional questions visibility
		updateProgressBar();
	});
};
